<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 mb-5">
        <Uploader @upload="uploader"> </Uploader>
      </div>
      <div class="col-6"></div>
      <div class="col-6">
        <button @click="SubmitData" class="btn btn-success w-100">بارگذاری فایــل</button>
      </div>
    </div>
  </div>
</template>
<script>
import Uploader from '@/components/Uploader/Uploader.vue'
export default {
  data() {
    return {
      file: null,
    }
  },
  components: { Uploader },
  props: ['master'],
  methods: {
    uploader(data) {
      this.file = data
    },
    SubmitData() {
      if (this.file != null) {
        var formData = new FormData()
        console.warn(this.master)
        formData.append('Id', this.master.Id)
        formData.append('file', this.file)
        formData.append('tblUserGrpIdLastEdit', this.$session.get('UserInfo').tblUserGrpId)
        formData.append('FilePath', 'AndicatorFile' + '\\' + this.master.Codebazaryabi + '\\' + this.master.tblComboGrp36Noename)
        var DataAxios = { Method: 'POST', Action: 'Andicator/AddFile', ArryfildValue: null }
        DataAxios.ArryfildValue = formData
        this.$PostFormData(DataAxios).then((result) => {
          if (result.status == 'success') {
            this.$toasted.info('فایل بارگذاری شد', {
              action: {
                text: '',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.$emit('Done', {
              done: 'OK',
            })
            this.$store.state.Modal = false
          } else {
            this.$toasted.error(result.msg, {
              action: {
                text: '',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          }
        })
      }
    },
  },
  created() {
    console.log(this.master)
  },
}
</script>
